import Title from '../../../../../chief-types/src/Title';
import useApi, { PaginationOptions } from '../../Hooks/UseApi';

const useTitles = (autoload: boolean = false) =>
  useApi<Title, PaginationOptions>('titles', { limit: 10, page: 1 }, autoload);

export default useTitles;
